const STORAGE_KEY = "restaurant_erp_offline_pos_queue";

function readQueue() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeQueue(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

export function getOfflineQueueCount() {
  return readQueue().length;
}

export function enqueueOfflinePayment(entry) {
  const items = readQueue();
  items.push({
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    created_at: new Date().toISOString(),
    ...entry,
  });
  writeQueue(items);
  return items.length;
}

export function listOfflineQueue() {
  return readQueue();
}

export function removeOfflineEntry(id) {
  writeQueue(readQueue().filter((e) => e.id !== id));
}

export function isNetworkError(err) {
  if (!err) return false;
  if (err.code === "ERR_NETWORK" || err.message === "Network Error") return true;
  return !err.response && Boolean(err.request);
}

export function isOffline() {
  return typeof navigator !== "undefined" && navigator.onLine === false;
}
